/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER } from '@gh/builder-shared-data';

import { createRoute } from '@gh/builder-shared';
import { ReportFyaDetailsComponent } from './components/report-financials-ytd-average-details/report-fya-details.component';

import { ReportRohcDetailsComponent } from './components/report-region-office-house-cost-details/report-rohc-details.component';
import { ReportSettingsTabContainerComponent } from './components/report-settings-tab-container/report-settings-tab-container.component';
import { ReportFyaDetailsBusinessService } from './resources/report-fya-details-business.service';
import { ReportRohcDetailsBusinessService } from './resources/report-rohc-details-business.service';

const routes = [
  createRoute(({
    component: ReportSettingsTabContainerComponent,
    path: '',
    children: [
      createRoute({
        component: ReportRohcDetailsComponent,
        path: 'region-office-house-cost',
        init: ReportRohcDetailsBusinessService,
        leave: true,
        auth: {
          applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
        },
      }),
      createRoute({
        component: ReportFyaDetailsComponent,
        path: 'financials-ytd-average',
        init: ReportFyaDetailsBusinessService,
        leave: true,
        auth: {
          applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
        },
      }),
    ],
  })),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupReportSettingsRoutingModule {
}
